module.exports = __webpack_public_path__ + "static/img/header__copy--join.377b4d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/simple/header__copy--join.png
// module id = GAYg
// module chunks = 1